module.exports = __webpack_public_path__ + "img/amx-5.e8f5d6a2.webp";